import { module } from "modujs";
import * as cart from '@shopify/theme-cart';

/////////////////////////
// SHOPIFY CART
////////////////////////

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        return new Promise(async (resolve) => {
            // Store initial cart state
            this.cartInitialState = await this.getState();
            // Resolve promise
            resolve()
        })
    }

    /**
     * Retrieve cart state
     * Return state object
     */
    getState() {
        return cart.getState()
    }

    /**
     * Add item to cart with variant ID
     * Return state object
     */
    async addItem({ id, quantity = 1 }) {
        try {
            await cart.addItem(id, {quantity})
        } catch (error) {
            // Can't add another item, quantity max
            if (error.status === 422) {
                this.onCannotAddMoreItem?.(id)
                alert("Sorry you can't add more item")
                return false
            }
        }
        const cartState = await this.refresh()

        // add property to cartState
        cartState.latestItemAddedId = id

        this.onAddItem?.(cartState)
        return cartState
    }

    /**
     * Remove item
     * Return state object
     */
    async removeItem(key) {
        const cartState = await cart.removeItem(key)
        this.onRemoveItem?.(cartState)
        return cartState
    }

    /**
     * Update item
     * Return state object
     */
     async updateItem({ key, quantity = 1 }) {
        const cartState = await cart.updateItem(key, {quantity})
        this.onUpdateItem?.(cartState)
        return cartState
    }

    /**
     * Retrieve cart state
     * Return state object
     */
    async refresh() {
        const cartState = await this.getState()
        this.onRefreshCart?.(cartState)
        return cartState
    }
    

    destroy() {
        super.destroy();
    }
}
